import { FunctionComponent, useEffect, useState, ReactNode, useMemo } from "react";
import Table from "../../../components/Table/Table";
import useIsMobile from "../../../hooks/useIsMobile";
import { ActiveExercise, ActiveParameter, useEndActiveWorkoutMutation } from "../../../graphql";
import { SuccessBadge, WarningBadge } from "./exercise-badges";
import { useTranslation } from "react-i18next";
import { endActiveWorkout } from "src/features/appsync/mutations";

interface ExercisesTableProps {
    workoutExercises: ActiveExercise[];
    onPressExercise?: (exerciseId: string) => any
}

const data = (workoutExercises: ActiveExercise[], t: (key: string) => string) => {

    return [
        ...workoutExercises.map((wex, i) => {
            const done = wex.__typename === "ActiveCardioExercise" ?
                wex.intervals?.reduce((prev, cur) => {
                    return prev && Boolean(cur?.end_at)
                }, true) : wex.__typename === "ActiveStrengthExercise" &&
                wex.sets?.reduce((prev, cur) => {
                    return prev && Boolean(cur?.end_at)
                }, true)

            return [
                wex?.name,
                <div className='max-w-[100px] text-ellipsis overflow-hidden'>{wex.__typename === "ActiveCardioExercise" ? "קרדיו" : "כוח"}</div>,
                "",
                "",
                done ? <SuccessBadge>{t("Done")}</SuccessBadge> : <WarningBadge>{t("Pending")}</WarningBadge>
            ]
        })]
}


const ExercisesTable: FunctionComponent<ExercisesTableProps> = ({ workoutExercises, onPressExercise }) => {

    const isMobile = useIsMobile();
    const [tableData, setTableData] = useState<ReactNode[][]>([])
    const [tableHeaders, setTableHeaders] = useState<string[]>([])
    const { t } = useTranslation();

    const [endActiveWorkout] = useEndActiveWorkoutMutation()

    const tableD = isMobile ? [...data(workoutExercises, t).map((v) => [v[0], v[4]])] : [...data(workoutExercises, t)]
    const tableH = useMemo(() => isMobile ? [t("Exercise Name"), t("Status")] : [t("Exercise Name"), t("section"), t("Machine Number"), t("Seat Height"), t("Status")], [isMobile, workoutExercises])

    useEffect(() => {
        const res = workoutExercises.map((wex) => wex.__typename === "ActiveCardioExercise" ?
            wex.intervals?.reduce((prev, cur) => {
                return prev && Boolean(cur?.end_at)
            }, true) : wex.__typename === "ActiveStrengthExercise" &&
            wex.sets?.reduce((prev, cur) => {
                return prev && Boolean(cur?.end_at)
            }, true))

        if (res.every(r => r)) {
            if (window.confirm("נראה שסיימת את כל התרגילים, לסיים את האימון?")) {
                endActiveWorkout({
                    onCompleted() {
                        window.location.href = "/";
                    }
                });
            }
        }
    }, [tableD])

    return (
        <section id="exercises">
            <article>
                <h1 className='light-orange'>{t("Exercises")}</h1>
                <Table hidePagination
                    onClickItem={(idx) => onPressExercise && onPressExercise(workoutExercises[idx]?.id!)}
                    headers={tableHeaders}
                    data={tableD}
                />
            </article>
        </section>
    );
}

export default ExercisesTable;